<template>
  <div>
    <Breadcrumbs title="Indices"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-4 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pb-0">
                <div class="media">
                  <div class="media-body">
                    <h5>KLCI</h5>
                    <h4 class="num total-value font-success float-right">+0%</h4>
                    <h4><span class="counter">
                      <countTo :startVal="3000" :endVal="3123" :duration="3000" :decimals="0"></countTo>
                    </span></h4>
                    <span class="font-roboto">KL Composite Index</span>
                  </div>
                  <span class="num">
                    <span class="counter"><countTo :startVal="0" :endVal="90" :duration="3000"></countTo> </span>
                    <i class="icon-angle-up f-12 ml-1"></i>
                  </span>
                </div>
              </div>
              <div>
                <div id="chart-widget1">
                  <apexchart height="170" type="area" :options="chart1.options" :series="chart1.series"></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-4 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pb-0">
                <div class="media">
                  <div class="media-body">
                    <h5>ACE</h5>
                    <h4 class="num total-value font-success float-right">+0%</h4>
                    <h4><span class="counter">
                      <countTo :startVal="3000" :endVal="3123" :duration="3000" :decimals="0"></countTo>
                    </span></h4>
                    <span class="font-roboto">ACE</span>
                  </div>
                  <span class="num">
                    <span class="counter"><countTo :startVal="0" :endVal="90" :duration="3000"></countTo> </span>
                    <i class="icon-angle-up f-12 ml-1"></i>
                  </span>
                </div>
              </div>
              <div id="chart-widget2">
                <div class="flot-chart-placeholder" id="chart-widget-top-second">
                  <apexchart height="170" type="area" :options="chart2.options" :series="chart2.series"></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-4 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pb-0">
                <div class="media">
                  <div class="media-body">
                    <h5>Small Cap</h5>
                    <h4 class="num total-value font-success float-right">+0%</h4>
                    <h4><span class="counter">
                      <countTo :startVal="3000" :endVal="3123" :duration="3000" :decimals="0"></countTo>
                    </span></h4>
                    <span class="font-roboto">Small Cap</span>
                  </div>
                  <span class="num">
                    <span class="counter"><countTo :startVal="0" :endVal="90" :duration="3000"></countTo> </span>
                    <i class="icon-angle-up f-12 ml-1"></i>
                  </span>
                </div>
              </div>
              <div id="chart-widget3">
                <div class="flot-chart-placeholder" id="chart-widget-top-third">
                  <apexchart height="170" type="area" :options="chart3.options" :series="chart3.series"></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pb-0">
                <div class="media">
                  <div class="media-body">
                    <h5>KLCI</h5>
                    <h4 class="num total-value font-success float-right">+0%</h4>
                    <h4><span class="counter">
                      <countTo :startVal="3000" :endVal="3123" :duration="3000" :decimals="0"></countTo>
                    </span></h4>
                    <span class="font-roboto">KL Composite Index</span>
                  </div>
                  <span class="num">
                    <span class="counter"><countTo :startVal="0" :endVal="90" :duration="3000"></countTo> </span>
                    <i class="icon-angle-up f-12 ml-1"></i>
                  </span>
                </div>
              </div>
              <div>
                <div id="chart-widget4">
                  <apexchart height="170" type="area" :options="chart1.options" :series="chart1.series"></apexchart>
                </div>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-4 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pb-0">
                <div class="media">
                  <div class="media-body">
                    <h5>ACE</h5>
                    <h4 class="num total-value font-success float-right">+0%</h4>
                    <h4><span class="counter">
                      <countTo :startVal="3000" :endVal="3123" :duration="3000" :decimals="0"></countTo>
                    </span></h4>
                    <span class="font-roboto">ACE</span>
                  </div>
                  <span class="num">
                    <span class="counter"><countTo :startVal="0" :endVal="90" :duration="3000"></countTo> </span>
                    <i class="icon-angle-up f-12 ml-1"></i>
                  </span>
                </div>
              </div>
              <div id="chart-widget5">
                <apexchart height="170" type="area" :options="chart2.options" :series="chart2.series"></apexchart>
              </div>
            </div>
          </px-card>
        </div>
        <div class="col-xl-4 col-md-12 box-col-12">
          <px-card class="o-hidden">
            <div class="chart-widget-top">
              <div class="card-body pb-0">
                <div class="media">
                  <div class="media-body">
                    <h5>Small Cap</h5>
                    <h4 class="num total-value font-success float-right">+0%</h4>
                    <h4><span class="counter">
                      <countTo :startVal="3000" :endVal="3123" :duration="3000" :decimals="0"></countTo>
                    </span></h4>
                    <span class="font-roboto">Small Cap</span>
                  </div>
                  <span class="num">
                    <span class="counter"><countTo :startVal="0" :endVal="90" :duration="3000"></countTo> </span>
                    <i class="icon-angle-up f-12 ml-1"></i>
                  </span>
                </div>
              </div>
              <div id="chart-widget6">
                <apexchart height="170" type="area" :options="chart3.options" :series="chart3.series"></apexchart>
              </div>
            </div>
          </px-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let primary = localStorage.getItem('primary_color') || '#7366ff';
let secondary = localStorage.getItem('secondary_color') || '#f73164';

import countTo from "vue-count-to";
// function generateData1(count, yrange) {
//   var i = 0;
//   var series = [];
//   while (i < count) {
//     var x = "w" + (i + 1).toString();
//     var y =
//       Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
//
//     series.push({
//       x: x,
//       y: y,
//     });
//     i++;
//   }
//   return series;
// }
// function generateData(baseval, count, yrange) {
//   var i = 0;
//   var series = [];
//   while (i < count) {
//     var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
//     var y =
//         Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
//     var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
//
//     series.push([x, y, z]);
//     baseval += 86400000;
//     i++;
//   }
//   return series;
// }

export default {
  components: {
    countTo,
  },
  data() {
    return {
      chart1: {
        options: {
          chart: {
            width: 510,
            height: 190,
            type: 'area',
            toolbar: {
              show: false,
            },
          },
          colors: [primary],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          xaxis: {
            show: false,
            type: 'datetime',
            categories: [
              '2018-09-19T00:00:00',
              '2018-09-19T01:30:00',
              '2018-09-19T02:30:00',
              '2018-09-19T03:30:00',
              '2018-09-19T04:30:00',
              '2018-09-19T05:30:00',
              '2018-09-19T06:30:00',
              '2018-09-19T07:30:00',
              '2018-09-19T08:30:00',
              '2018-09-19T09:30:00',
            ],
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          fill: {
            colors: [primary],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm',
            },
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: -10,
              bottom: -50,
            },
          },
        },
        series: [
          {
            name: 'series1',
            data: [14, 12, 20, 20, 14, 22, 18, 26, 12, 18, 0],
          },
        ],
      },
      chart2: {
        options: {
          chart: {
            width: 510,
            height: 190,
            type: 'area',
            toolbar: {
              show: false,
            },
          },
          colors: [secondary],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2
          },
          xaxis: {
            show: false,
            type: 'datetime',
            categories: [
              '2018-09-19T00:00:00',
              '2018-09-19T01:30:00',
              '2018-09-19T02:30:00',
              '2018-09-19T03:30:00',
              '2018-09-19T04:30:00',
              '2018-09-19T05:30:00',
              '2018-09-19T06:30:00',
              '2018-09-19T07:30:00',
              '2018-09-19T08:30:00',
              '2018-09-19T09:30:00',
            ],
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          fill: {
            colors: [secondary],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm',
            },
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: -10,
              bottom: -50,
            },
          },
        },
        series: [
          {
            name: 'series1',
            data: [14, 12, 20, 20, 14, 22, 18, 26, 12, 18, 0],
          },
        ],
      },
      chart3: {
        options: {
          chart: {
            width: 510,
            height: 190,
            type: 'area',
            toolbar: {
              show: false,
            },
          },
          colors: ['#51BB25'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          xaxis: {
            show: false,
            type: 'datetime',
            categories: [
              '2018-09-19T00:00:00',
              '2018-09-19T01:30:00',
              '2018-09-19T02:30:00',
              '2018-09-19T03:30:00',
              '2018-09-19T04:30:00',
              '2018-09-19T05:30:00',
              '2018-09-19T06:30:00',
              '2018-09-19T07:30:00',
              '2018-09-19T08:30:00',
              '2018-09-19T09:30:00',
            ],
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          fill: {
            colors: ['#51BB25'],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm',
            },
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: -10,
              bottom: -50,
            },
          },
        },
        series: [
          {
            name: 'series1',
            data: [14, 12, 20, 20, 14, 22, 18, 26, 12, 18, 0],
          },
        ],
      },
    }
  }
}
</script>